import { useState, type FormEvent } from 'react';
import { errorText } from '../api';
import { adminApi, type Identity } from './api';

export function AccountPage({ identity }: { identity: Identity }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<{ kind: 'ok' | 'error'; text: string } | null>(null);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setMessage(null);
    try {
      await adminApi.changePassword(current, next);
      setCurrent('');
      setNext('');
      setMessage({ kind: 'ok', text: 'Dein Passwort ist geändert. Andere Geräte sind abgemeldet.' });
    } catch (e) {
      setMessage({ kind: 'error', text: errorText(e) });
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <div className="admin-head">
        <h1>Konto</h1>
      </div>
      <div className="admin-grid">
        <form className="card" onSubmit={submit}>
          <h2 className="card__title">Passwort ändern</h2>
          <p className="muted small">Angemeldet als {identity.user.email}</p>
          <div className="field">
            <label htmlFor="current">Bisheriges Passwort</label>
            <input id="current" type="password" autoComplete="current-password" required value={current} onChange={(e) => setCurrent(e.target.value)} />
          </div>
          <div className="field">
            <label htmlFor="next">Neues Passwort</label>
            <input id="next" type="password" autoComplete="new-password" required minLength={10} value={next} onChange={(e) => setNext(e.target.value)} />
            <span className="muted small">Mindestens 10 Zeichen.</span>
          </div>
          {message && <div className={message.kind === 'ok' ? 'success' : 'error'}>{message.text}</div>}
          <div>
            <button type="submit" className="button" disabled={busy}>
              {busy ? 'Einen Moment …' : 'Passwort ändern'}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
